import React from 'react';
import ToggleSectionDefault from './components/default';
import ToggleSectionField from './components/field';
const ToggleSection = ({
  children = null,
  title,
  popoverProps = undefined,
  value = undefined,
  defaultValue = true,
  onReload = undefined,
  onChange = Function.prototype,
  control = undefined,
  name = undefined,
  rules = undefined,
}) => {
  const sharedProps = {
    children,
    title,
    popoverProps,
    onReload,
    onChange,
  };

  if (control && name) {
    return <ToggleSectionField {...sharedProps} control={control} name={name} rules={rules} />;
  }

  return <ToggleSectionDefault {...sharedProps} value={value} defaultValue={defaultValue} />;
};

export default ToggleSection;
